export class Ocupacion{
    usuarioId:number;
    tipoEmpresaId: number;
    tipoPuestoEmpresaId:number;
}